import { ROUTES } from '@repo/studio-utils/routes'
import { getStudioLanguageFromPathname } from '@repo/react-router-locale/canonicalize-studio-locale-pathname'
import { canonicalizeStudioLocaleTo } from '@repo/react-router-locale/canonicalize-studio-locale-to'
import type { DefaultPlan } from 'payments/payments-dialog/lib/plans'
import { TRIAL_CTA_VARIANTS } from './features'
import type { TrialCtaVariant } from './features'

/** The plan the payments dialog falls back to, which is the free trial for anyone eligible. */
export function isDefaultStudioAiPlan(plan: DefaultPlan | undefined): boolean {
  return plan === undefined || plan === 'aiStudio'
}

export function pricingPageHref(currentPathname: string): string {
  const language = getStudioLanguageFromPathname(currentPathname)

  return language ? canonicalizeStudioLocaleTo(ROUTES.PRICING.ROOT, language) : ROUTES.PRICING.ROOT
}

export interface TrialCta {
  label: string
  onClick: () => void
}

export function resolveTrialCta({
  variant,
  isLoggedIn,
  trialLabel,
  pricingLabel,
  tracksControlClicks,
  openPaymentsDialog,
  navigateTo,
  trackPricingCtaClicked,
}: {
  variant: TrialCtaVariant
  isLoggedIn: boolean
  trialLabel: string
  pricingLabel: string
  tracksControlClicks: boolean
  openPaymentsDialog: () => void
  navigateTo: (path: string) => void
  trackPricingCtaClicked: (props: { isLoggedIn: boolean; variant: TrialCtaVariant }) => void
}): TrialCta {
  const isPricingPage = variant === TRIAL_CTA_VARIANTS.pricingPage

  return {
    label: isPricingPage ? pricingLabel : trialLabel,
    onClick: () => {
      if (isPricingPage || tracksControlClicks) {
        trackPricingCtaClicked({ isLoggedIn, variant })
      }

      if (isPricingPage) {
        navigateTo(ROUTES.PRICING.ROOT)
        return
      }

      openPaymentsDialog()
    },
  }
}
